import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface DeleteSessionByIdParams {
  id: string;
}

export const deleteSessionByIdAPI = async (params: DeleteSessionByIdParams) => {
  const resp = await baseAPI.delete<unknown>(`/session/${params.id}`);
  return resp.data;
};

export const useDeleteSessionByIdMutation = () => {
  return useMutation({
    mutationFn: async (params: DeleteSessionByIdParams) => {
      const response = await deleteSessionByIdAPI(params);
      return response;
    },
    onSuccess: (_d) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SESSIONS],
      });
      // Drop the cached classes search response so the All Classes filter
      // dropdown no longer offers the deleted session as an option.
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASSES],
      });
    },
  });
};
